module.exports = __webpack_public_path__ + "img/grid_image.4fbe39ed.png";